import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser';
import { isEmpty } from 'lodash';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import PropTypes from 'prop-types';

const searchAndReplaceTokens = (tokenStr, tokenData) => {
  if (tokenStr && tokenData) {
    const tokens = {};
    tokenStr.replace(/%(.*?)%/g, (a, b) => {
      tokens[a] = b;
    });

    Object.entries(tokens).forEach(entry => {
      const [token, tokenKey] = entry;
      const value = tokenData[tokenKey] ?? 'N/A';
      if (typeof value == 'string') {
        const regExp = new RegExp(token, 'ig');
        tokenStr = tokenStr.replace(regExp, value);
      } else {
        let tokenObj = JSON.parse(tokenStr);
        for (let att in tokenObj) {
          if (tokenObj[att] === token) {
            tokenObj[att] = value;
          }
        }
        tokenStr = JSON.stringify(tokenObj);
      }
    });
  }
  return tokenStr;
};

export const StructureData = ({ page, seoObj, seoTemplate }) => {
  const [structuredData, setStructuredData] = useState(null);
  const [templateData, setTemplateData] = useState('');

  const { seoContent } = useSelector(data => {
    return {
      seoContent: data?.contentReducer?.response?.seoStructureData ?? null,
    };
  });

  useEffect(() => {
    const seoData = { ...seoObj, PageURL: window?.location?.href ?? '', HomeURL: window?.location?.origin ?? '/' };
    if (!isEmpty(seoContent)) {
      const seoTemplateData = seoTemplate ?? seoContent?.seo?.find(item => item.fields?.title === page) ?? {};
      const { fields: { templateData: pageTemplateData = {}, data: pageStructuredData = {} } = {} } = seoTemplateData;
      const { template = {} } = seoContent ?? {};
      const templateHtmlStr = documentToHtmlString(template);

      if (!isEmpty(templateHtmlStr)) {
        let templateStr = parse(templateHtmlStr.replace(/<p>|<\/p>/gi, ''));
        templateStr = searchAndReplaceTokens(templateStr, pageTemplateData);
        templateStr = searchAndReplaceTokens(templateStr, seoData);
        const parsedTemplateStr = parse(templateStr);
        setTemplateData(parsedTemplateStr);
      }

      if (!isEmpty(pageStructuredData)) {
        let templateSd = JSON.stringify(pageStructuredData);
        templateSd = searchAndReplaceTokens(templateSd, seoData);
        setStructuredData(templateSd);
      }
    }
  }, [page, seoContent, seoObj, seoTemplate]);

  return (
    <Helmet>
      {templateData}
      <script type='application/ld+json'>{structuredData}</script>
    </Helmet>
  );
};

StructureData.propTypes = {
  page: PropTypes.string.isRequired,
  seoTemplate: PropTypes.object,
  seoObj: PropTypes.object,
};

StructureData.defaultProps = {
  page: '',
  seoTemplate: null,
  seoObj: null,
};

export default StructureData;
